import { TAX_RATES } from "../../../../utils/taxRates";

export const TAX_SLABS = {
  THRESHOLD: TAX_RATES.ROOM.THRESHOLD,
  LOW_RATE: TAX_RATES.ROOM.LOW.PERCENT,
  HIGH_RATE: TAX_RATES.ROOM.HIGH.PERCENT,
};

export const EMPTY_LINE_ITEM = {
  description: "Extra Service",
  qty: 1,
  inclusiveRate: 0,
  inclusiveAmount: 0,
  base: 0,
  sgst: 0,
  cgst: 0,
  taxRate: 0,
};